import Modal from "./Modal";
import useDonorsModal from "../../hooks/post/useDonorsModal";
import { useGetPostDonorListQuery } from "../../services/postApis";
import { useTranslation } from "react-i18next";
import { multiFormatDateString } from '../../utils/DateConvertor';


const DonorsModal = ({ slug }) => {

  const donorsModal = useDonorsModal();
  const { data: donorList, isLoading} = useGetPostDonorListQuery(slug, {skip: !donorsModal.isOpen,});

  const {t} = useTranslation("post")
  const translation = t('post-donors')

  const DonorCard = ({ donor, amount, created, status, currency, index }) => (
    <div
      className="
        flex flex-col sm:flex-row items-start sm:items-center p-4 m-2
        bg-white dark:bg-gray-800 rounded-xl shadow-lg
        hover:shadow-xl transition-all duration-300 group
        border border-gray-200 dark:border-gray-700
      "
      key={index} // Key should ideally be a unique ID from the donor data, not index
    >
      {/* Donor Icon */}
      <div className="flex-shrink-0 mb-4 sm:mb-0 sm:mr-4">
        <div className="w-12 h-12 rounded-full bg-gradient-to-br from-indigo-500 to-purple-600 flex items-center justify-center shadow-md">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-7 w-7 h-7 text-white">
            <path fillRule="evenodd" d="M18.685 19.097A9.723 9.723 0 0 0 21.75 12c0-5.385-4.365-9.75-9.75-9.75S2.25 6.615 2.25 12a9.723 9.723 0 0 0 3.065 7.097A9.716 9.716 0 0 0 12 21.75a9.716 9.716 0 0 0 6.685-2.653Zm-12.54-1.285A7.486 7.486 0 0 1 12 15a7.486 7.486 0 0 1 5.855 2.812A8.224 8.224 0 0 1 12 20.25a8.224 8.224 0 0 1-5.855-2.438ZM15.75 9a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0Z" clipRule="evenodd" />
          </svg>
        </div>
      </div>

      {/* Donor Details (Name, Amount, Date, Status) */}
      <div className="flex-1 min-w-0 w-full">
        {/* Donor Name */}
        <p className="text-xl font-semibold text-gray-900 dark:text-gray-100 truncate mb-1">
          {donor}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-2 text-sm text-gray-700 dark:text-gray-300">
          {/* Amount */}
          <div className="flex items-center">
            <span className="font-medium mr-1">{translation.amount}</span>
            {amount > 0 ? (
              <span className="font-bold text-green-600 dark:text-green-400">
                {amount.toLocaleString('en', {
                  style: 'currency',
                  currency: `${currency}`,
                  minimumFractionDigits: 0,
                  maximumFractionDigits: 0
                })}
              </span>
            ) : (
              <span className="font-bold text-yellow-600 dark:text-yellow-400">{translation.verifying}</span>
            )}
          </div>

          {/* Date */}
          <div className="flex items-center">
            <span className="font-medium mr-1">{translation.date}</span>
            <span className="font-bold text-blue-600 dark:text-blue-400">{created}</span>
          </div>

          {/* Status */}
          <div className="flex items-center">
            <span className="font-medium mr-1">{translation.status}</span>
            <span className={`font-bold ${status === 'completed' ? 'text-green-600 dark:text-green-400' : 'text-orange-600 dark:text-orange-400'}`}>
              {status}
            </span>
          </div>
        </div>
      </div>
    </div>
  );


  const content = (
    <div className="grid grid-cols-1 md:grid-cols-1 gap-8 mb-4">
      
      {isLoading && (
        <p className="text-slate-950 dark:text-stone-200">{translation.loading_donors}</p>
      )}

      {donorList ? (
        <div className="text-slate-950 dark:text-stone-200 overflow-scroll max-h-screen">
          {donorList.map((object, index) => (
            <DonorCard
              key={index}
              donor={object.user}
              amount={object.display_amount}
              created={multiFormatDateString(object.created)}
              status={object.status}
              currency={object.currency}
            />
          ))}
        </div>
      ) : (
        !isLoading && (
          <p className="text-slate-950 dark:text-stone-200">
            {translation.no_donor}
          </p>
        )
      )}
    </div>
  );

  return (
    <Modal
      isOpen={donorsModal.isOpen}
      close={donorsModal.close}
      label={translation.heading}
      content={content}
    />
  );
};

export default DonorsModal;
